export const HORIZON_ACCESSOR_ERRORED = "HORIZON_ACCESSOR_ERRORED";
export const HORIZON_ACCESSOR_SUCCESS = "HORIZON_ACCESSOR_SUCCESS";
